import React, { useState } from 'react';

const SEOFooter = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  
  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  
  return (
    <div className="seo-footer" style={{
      padding: '1rem 1rem',
      backgroundColor: '#f9fafb',
      borderTop: '1px solid #e5e7eb',
      marginTop: '2rem',
      textAlign: 'center',
      fontSize: '0.875rem',
      color: '#6b7280'
    }}>
      <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
        <button 
          onClick={toggleExpand}
          aria-expanded={isExpanded}
          style={{
            background: 'none',
            border: 'none',
            color: '#4b5563',
            fontSize: '0.875rem',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            margin: '0 auto',
            padding: '0.5rem 1rem',
            borderRadius: '0.375rem',
            transition: 'background-color 0.2s',
            backgroundColor: isExpanded ? '#e5e7eb' : 'transparent'
          }}
        >
          {isExpanded ? 'Hide game information' : 'Show game information'}
          <span style={{ 
            marginLeft: '0.5rem',
            transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s'
          }}>
            ▼
          </span>
        </button>
        
        {isExpanded && (
          <div 
            style={{ 
              maxHeight: isExpanded ? '1000px' : '0',
              overflow: 'hidden',
              transition: 'max-height 0.3s ease-in-out',
              padding: isExpanded ? '1rem 0' : '0',
            }}
          >
            <h2 style={{ fontSize: '1.25rem', color: '#4b5563', marginBottom: '1rem' }}>
              About Qwixx Online
            </h2>
            
            <p style={{ marginBottom: '1rem', lineHeight: '1.5' }}>
              Qwixx Online is a free multiplayer browser version of the popular dice game Qwixx, designed by Steffen Benndorf. 
              Play with 2-4 players online with friends from anywhere in the world.
            </p>
            
            <p style={{ marginBottom: '1rem', lineHeight: '1.5' }}>
              This fast-paced dice game combines strategy, luck, and quick decision-making as players compete to mark off 
              numbers on their colorful scorecards. With simple rules but challenging gameplay, Qwixx is perfect for 
              family game nights, casual gaming with friends, or competitive online matches.
            </p>
            
            <div style={{ marginTop: '1.5rem', borderTop: '1px solid #e5e7eb', paddingTop: '1.5rem' }}>
              <h3 style={{ fontSize: '1rem', color: '#4b5563', marginBottom: '0.75rem' }}>
                Game Features
              </h3>
              
              <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '1rem' }}>
                <li style={{ padding: '0.5rem 1rem', backgroundColor: 'white', borderRadius: '0.375rem', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>Free to play</li>
                <li style={{ padding: '0.5rem 1rem', backgroundColor: 'white', borderRadius: '0.375rem', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>No downloads</li>
                <li style={{ padding: '0.5rem 1rem', backgroundColor: 'white', borderRadius: '0.375rem', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>Mobile friendly</li>
                <li style={{ padding: '0.5rem 1rem', backgroundColor: 'white', borderRadius: '0.375rem', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>2-4 players</li>
                <li style={{ padding: '0.5rem 1rem', backgroundColor: 'white', borderRadius: '0.375rem', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>Multiple languages</li>
                <li style={{ padding: '0.5rem 1rem', backgroundColor: 'white', borderRadius: '0.375rem', boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>Quick setup</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default SEOFooter; 